/**
 * Passive event listeners
 */
// eslint-disable-next-line max-classes-per-file
jQuery.event.special.touchstart = {
	setup(_, ns, handle) {
		this.addEventListener('touchstart', handle, { passive: !ns.includes('noPreventDefault') });
	},
};
jQuery.event.special.touchmove = {
	setup(_, ns, handle) {
		this.addEventListener('touchmove', handle, { passive: !ns.includes('noPreventDefault') });
	},
};

/**
 * Global vars
 */
const $window = $(window);
const $document = $(document);
const $body = $('body');
const $siteWrapper = $('#site-wrapper');
// eslint-disable-next-line no-unused-vars
let slidingPanel;
const slidingPanelOpenAnimDuration = 300;
const slidingPanelCloseAnimDuration = 300;
const loadingAnimOutDuration = 400;
const assetsDistPath = `${$siteWrapper.data('template-directory-uri')}/assets/dist/`;
const documentRoot = document.querySelector(':root');

/**
 * Generate random number between two numbers
 */
function randomIntFromInterval(min, max) { // min and max included
	return Math.floor(Math.random() * (max - min + 1) + min);
}

/**
 * Scroll to hashtag on load
 */
function scrollToHashtagOnLoad() {
	if (window.location.hash) {
		const $hash = $(window.location.hash);

		if ($hash.length) {
			$('html, body').animate({
				scrollTop: $hash.offset().top - 120,
			}, 1000);
		}
	}
}

/**
 * Real Window Size
 */
function viewportSize() {
	let viewportwidth;
	let viewportheight;

	if (typeof window.innerWidth !== 'undefined') { // the more standards compliant browsers (mozilla/netscape/opera/IE7) use window.innerWidth and window.innerHeight
		viewportwidth = window.innerWidth;
		viewportheight = window.innerHeight;
	} else if (typeof document.documentElement !== 'undefined' && typeof document.documentElement.clientWidth !== 'undefined' && document.documentElement.clientWidth !== 0) { // IE6 in standards compliant mode (i.e. with a valid doctype as the first line in the document)
		viewportwidth = document.documentElement.clientWidth;
		viewportheight = document.documentElement.clientHeight;
	} else { // older versions of IE
		viewportwidth = document.getElementsByTagName('body')[0].clientWidth;
		viewportheight = document.getElementsByTagName('body')[0].clientHeight;
	}

	return {
		x: viewportwidth,
		y: viewportheight,
	};
}

/**
 * Register GSAP ScrollTrigger
 */
const { gsap } = window;
const { ScrollTrigger } = window;
gsap.registerPlugin(ScrollTrigger);
gsap.ticker.fps(-1);

const { is } = window;

/**
 * Document ready
 */
$document.ready(() => {
	/**
	 * Multiple use vars
	 */
	const $slidingPanel = $('#sliding-panel');

	/**
	 * Enable scroll bar for windows user
	 */
	if (is.windows()) {
		$body.addClass('no-swipe');
	}

	/**
	 * If banner
	 */
	if ($('.head-banner').length) {
		$body.addClass('has-banner');
	}

	/**
	 * Check if page landing
	 */
	if ($body.hasClass('single-landings')) {
		$('.cta').addClass('cta-landing');
	}

	/**
	 * Enable / disable scroll
	 */
	const keys = {
		37: 1, 38: 1, 39: 1, 40: 1,
	};

	function preventDefault(e) {
		e.preventDefault();
	}

	// eslint-disable-next-line consistent-return
	function preventDefaultForScrollKeys(e) {
		if (keys[e.keyCode]) {
			preventDefault(e);
			return false;
		}
	}

	let supportsPassive = false;
	try {
		window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
			// eslint-disable-next-line getter-return
			get() { supportsPassive = true; },
		}));
	} catch (e) {
		// catch it
	}

	const wheelOpt = supportsPassive ? { passive: false } : false;
	const wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
	function disableScroll() {
		if ($window.width() > 991) {
			window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
			window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
			window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
			window.addEventListener('keydown', preventDefaultForScrollKeys, false);
		}
	}

	function enableScroll() {
		window.removeEventListener('DOMMouseScroll', preventDefault, false);
		window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
		window.removeEventListener('touchmove', preventDefault, wheelOpt);
		window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
	}

	/**
	 * Real Window Size trigger
	 */
	viewportSize();

	$window.on('resize', viewportSize);

	/**
	 * Body class scroll
	 */
	if ($('.one-image').length) {
		$body.addClass('transparent-nav');
	}

	if ($('.heading-wrapper').data('midnight') === 'tea-200' || $('.blog').length) {
		$body.addClass('light-theme-alt');
	}

	$window.on('scroll', () => {
		if ($window.scrollTop() > 10) {
			$body.addClass('has-scrolled');
		} else {
			$body.removeClass('has-scrolled');
		}
	});

	/**
	 * Sliding panel
	 */
	slidingPanel = $slidingPanel.slidingPanel({
		closeButtonContent: `<span class="icon icon-cross"><svg aria-hidden="true"><use xlink:href="${assetsDistPath}images/svg/sprite.svg#cross"></use></svg></span><span class="sr-only">Fermer</span>`,
		contentToClone: null,
		transitionDurationOnClose: slidingPanelCloseAnimDuration,
		transitionDurationOnOpen: slidingPanelOpenAnimDuration,
	});

	const btnClose = $('.btn-close-sliding-panel');
	btnClose.on('click', enableScroll);

	/**
	 * Home header nav white
	 */
	$('.l-navigation-wrapper').midnight();

	/**
	 * Navigation buttons
	 */
	class NavItems {
		constructor(target, classToggle) {
			this.target = target;
			this.classToggle = classToggle;
		}

		get elTarget() {
			return this.target;
		}
	}

	const navBtnsArray = [];
	const navBtns = $('.nav-list button');
	navBtns.each((i, el) => {
		const $el = $(el);
		navBtnsArray.push(new NavItems($el.data('target'), 'open'));
		$el.on('click', () => {
			const thisTarget = $(navBtnsArray[i].target);
			const thisClass = navBtnsArray[i].classToggle;
			const openedPanel = $(`.panel.${thisClass}`);

			function openPanels() {
				thisTarget.addClass(thisClass); // opens panel
				$el.addClass(thisClass); // opened state on button
				$body.addClass('panels-opened');

				if ($window.width() > 1439) {
					disableScroll();
				}
			}

			function closePanels() {
				thisTarget.removeClass(thisClass);
				$el.removeClass(thisClass);
				$body.removeClass('panels-opened');
				enableScroll();
			}

			if (!thisTarget.hasClass(thisClass)) {
				if (openedPanel.length) {
					openedPanel.removeClass(thisClass); // closes other panels
					$body.addClass('panels-changing');

					setTimeout(() => {
						$body.removeClass('panels-changing');
					}, 600);
				}

				if (navBtns.hasClass(thisClass)) {
					navBtns.removeClass(thisClass); // removed opened state on other buttons
				}

				openPanels();
			} else if ($el.hasClass(thisClass) || thisTarget.hasClass(thisClass)) {
				closePanels();
			}

			$('.overflow, .l-navigation-xl-panels .btn-close').on('click', closePanels);
		});
	});

	$('.back-to-main').on('click', () => {
		navBtns.removeClass('open');
		$('.panel').removeClass('open');
		$body.removeClass('panels-opened');
	});

	/**
	 * Check where to put spanish icon
	 */
	const mainLinks = $('.main-links');
	mainLinks.each((i, e) => {
		const text = $(e).find('.text');

		if (text.text().toLowerCase().includes('mexi')) {
			$(e).append(`<svg class="es"><use xlink:href="${assetsDistPath}/images/svg/sprite.svg#bubble-es"></use></svg>`);
		}
	});

	/**
	 * Sticky account side nav
	 */
	$('.m-account-dashboard-nav .sticky-wrapper').stick_in_parent({
		offset_top: 128,
	});

	/**
	 * Form change billing infos
	 */
	const addressFields = $('.c-form-change-address');
	if (addressFields.length) {
		const currentInfos = [];

		currentInfos.push($('#name'), $('#address-street'), $('#city'), $('#prov'), $('#address-zip'), $('#address-country'), $('#phone'));

		$('#modify-billing-infos').on('submit', () => {
			const fields = addressFields.find('.form-control');

			fields.each((i, e) => {
				const value = $(e).val();
				currentInfos[i].text(value);
			});

			$('.form-notes').text('');

			$('.close-filters').click();

			return false;
		});
	}

	/**
	 * Password input show / hide
	 */
	if ($('.password-field').length) {
		const btns = $('.password-field button[type=button]');
		const passwordInput = $('.password-field input');
		btns.each((i, el) => {
			const $el = $(el);
			$el.on('click', () => {
				if ($el.hasClass('see')) {
					$el.addClass('hide').removeClass('see');
					passwordInput.attr('type', 'text');
				} else if ($el.hasClass('hide')) {
					$el.addClass('see').removeClass('hide');
					passwordInput.attr('type', 'password');
				}
			});
		});
	}

	/**
	 * Control layout
	 */
	const layoutsButton = $('.control-layout .btn');
	if (layoutsButton.length) {
		layoutsButton.each((i, e) => {
			const target = $(e).data('target');
			const columns = $(e).data('cols');

			$(e).on('click', () => {
				if (layoutsButton.hasClass('selected')) {
					layoutsButton.removeClass('selected');
				}

				$(e).addClass('selected');
				$(target).removeClass();
				$(target).addClass(`grid-${columns}`);
			});
		});
	}

	/**
	 * Make sure form-group radio with diabled input has class disabled
	 */
	const radioGroup = $('.radio-group');
	if (radioGroup.length) {
		radioGroup.each((i, el) => {
			const $el = $(el);
			const $elInput = $el.find('input');

			if ($elInput.attr('disabled') !== undefined && !$el.hasClass('disabled')) {
				$el.addClass('disabled');
			}
		});
	}

	/**
	 * Scroll to message on form submission
	 */
	const form = $('.c-form');
	const wpcf7Elm = document.querySelector('.wpcf7');

	async function scrollToMsg(event) {
		const isContactForm = $(event.target).parents('.m-about').length;
		if (isContactForm) {
			const $response = form.find('.wpcf7-response-output');

			// attendre que la réponse soit revenu, sinon ça fait un carré vide et ça l'air buggé
			const waitForMsg = setInterval(() => {
				if ($response.is(':visible') && $response[0].innerHTML.trim() !== '') {
					clearInterval(waitForMsg);
					form.find('form').children().each((i, el) => {
						const $el = $(el);
						if (!$el.hasClass('wpcf7-response-output')) {
							$el.hide();
						}
					});
					$('html, body').animate({
						scrollTop: form.offset().top + form.outerHeight(true) - 400,
					}, 1000);
				}
			}, 100);
		} else {
			$('html, body').animate({
				scrollTop: form.offset().top + form.outerHeight(true) - 300,
			}, 1000);
		}
	}

	if (wpcf7Elm) {
		wpcf7Elm.addEventListener('wpcf7mailsent', scrollToMsg);
		wpcf7Elm.addEventListener('wpcf7mailfailed', scrollToMsg);
	}

	/**
	 * Social share
	 */
	$('.fb-share').on('click', (e) => {
		e.preventDefault();
		window.open($(e.currentTarget).attr('href'), 'shareWindow', `height=450, width=580, top=${$window.height() / 2 - 275}, left=${$window.width() / 2 - 225}, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0`);
		return false;
	});

	/**
	 * Slider Toggle upsells Single de produit
	 */
	const options = $('.toggle-option');
	if (options.length) {
		options.each((i, el) => {
			const slider = $(el).find('.slider');

			slider.slick({
				infinite: false,
				arrows: false,
				dots: false,
				variableWidth: true,
				slidesToScroll: 1,
				slidesToShow: 1,
				touchmove: true,
				mobileFirst: true,
			});
		});
	}

	const toggleBtn = $('.bloc-toggle-upsells').find('.c-categories-nav button');
	toggleBtn.each((i, el) => {
		const target = $(el).data('target');
		$(el).on('click', () => {
			options.each((index2, e2) => {
				if ($(e2).hasClass('selected')) {
					$(e2).removeClass('selected');
				}
			});

			if (!$(target).hasClass('selected')) {
				$(target).addClass('selected');
			}

			toggleBtn.each((index, e) => {
				if ($(e).hasClass('selected')) {
					$(e).removeClass('selected');
				}
			});

			$(el).addClass('selected');

			if ($(el).data('color-scheme') === 'dark') {
				$('.bloc-toggle-upsells .editor').addClass('editor-alt-color');
				$('.upsells-module').addClass('dark').attr('data-midnight', 'white');
				setTimeout(() => {
					$('.l-navigation-wrapper').midnight('refreshMidnight');
				}, 100);
			} else {
				$('.bloc-toggle-upsells .editor').removeClass('editor-alt-color');
				$('.upsells-module').removeClass('dark').attr('data-midnight', 'black');
				setTimeout(() => {
					$('.l-navigation-wrapper').midnight('refreshMidnight');
				}, 100);
			}
		});
	});

	/**
	 * Tailor made pop-up
	 */
	const anchorTailor = $('.tailor-made');

	if (anchorTailor.length) {
		anchorTailor.magnificPopup({
			type: 'inline',
			midClick: true,
			mainClass: 'tailor',
			closeBtnInside: true,
			fixedContentPos: false,
			fixedBgPos: true,
			callbacks: {
				open: () => {
					$body.css('overflow', 'hidden');
				},

				close: () => {
					$body.css('overflow', '');
				},
			},
		});
	}

	/**
	 * Terms and conditions pop-up
	 */
	const $termsConditionsPopupLink = $('.terms-conditions-popup-link');

	$termsConditionsPopupLink.magnificPopup({
		type: 'inline',
		midClick: true,
		mainClass: 'tailor',
		closeBtnInside: true,
		fixedContentPos: false,
		fixedBgPos: true,
		callbacks: {
			open: () => {
				$body.css('overflow', 'hidden');
			},

			close: () => {
				$body.css('overflow', '');
			},
		},
	});

	/**
	 *  Holiday pop-up
	 */
	const holiday = $('.holiday');

	if (holiday.length) {
		holiday.magnificPopup({
			type: 'inline',
			midClick: true,
			mainClass: 'holiday',
			closeBtnInside: true,
			fixedContentPos: false,
			fixedBgPos: true,
			callbacks: {
				open: () => {
					$body.css('overflow', 'hidden');
				},

				close: () => {
					$body.css('overflow', '');
				},
			},
		});
	}

	/**
	 * Shop filters
	 */
	const filters = $('.filters');
	if (filters.length) {
		const openFilters = filters.find('.open-filters');
		const closeFilters = filters.find('.close-filters');
		const panels = filters.find('.filters-panel');
		const btnOpenFilters = document.querySelectorAll('.open-filters');

		if ($('.c-categories-nav > .open-filters').length) {
			$('.c-categories-nav > .open-filters').on('click', () => {
				openFilters.click();
			});
		}

		if (openFilters.length > 1 || btnOpenFilters.length) {
			btnOpenFilters.forEach((btn) => {
				btn.addEventListener('click', () => {
					const getTarget = btn.getAttribute('data-target');
					const target = document.querySelector(getTarget);

					if (target !== undefined) {
						target.classList.add('opened');
					} else {
						panels.addClass('opened');
					}
				});
			});
		} else if ($('.c-categories-nav > .open-filters').length) {
			$('.c-categories-nav > .open-filters').on('click', () => {
				openFilters.click();
			});
		}

		openFilters.on('click', () => {
			panels.addClass('opened');
		});

		closeFilters.on('click', () => {
			panels.removeClass('opened');
		});

		panels.on('submit', () => {
			closeFilters.click();
		});

		$('.filters-panel .before').on('click', () => {
			closeFilters.click();
		});
	}

	/**
	 * Product gallery
	 */
	if ($('.single-product-variable').length) {
		$('.single-product-variable .col-right .content').addClass('variable-product-content editor');

		$('button.tab').on('click', () => {
			ScrollTrigger.refresh('all');
		});

		let pinnedCol;
		ScrollTrigger.matchMedia({
			'(min-width: 992px)': function lg() {
				pinnedCol = ScrollTrigger.create({
					invalidateOnRefresh: true,
					trigger: '.single-product-variable',
					start: 'top top',
					end: 'bottom-=120px bottom+=92px',
					pin: '.single-product-variable .col-right .content',
					pinReparent: true,
					pinSpacer: '.single-product-variable .col-right',
				});
			},

			'(max-width: 991px)': function sm() {
				if (pinnedCol !== undefined) {
					pinnedCol.kill();
				}
			},
		});

		$('.product-gallery-imgs-sm').slick({
			arrows: false,
			dots: true,
		});
	}

	const sizeCharts = $('.size-charts');
	if (sizeCharts.length) {
		$('#openSCharts, #openSChartsSM').click(() => {
			if (!sizeCharts.hasClass('opened')) {
				sizeCharts.addClass('opened');
			}
		});

		$('.size-charts .btn-close, .size-charts .overflow').click(() => {
			if (sizeCharts.hasClass('opened')) {
				sizeCharts.removeClass('opened');
			}
		});
	}

	const productPage = $('.single-product');
	if (productPage.length) {
		ScrollTrigger.create({
			anticipatePin: 1,
			trigger: '.single-product',
			start: 'top-=90 top',
			end: 'bottom center',
			pin: '.single-product .back-to-prev .cta',
			pinReparent: true,
			invalidateOnRefresh: true,
		});
	}

	const gallery = $('.gallery, .has-no-gallery');
	if (gallery.length) {
		$('.product-img').each((i, e) => {
			$(e).magnificPopup({
				type: 'inline',
				midClick: true,
				mainClass: 'galleries',
				closeBtnInside: true,
				fixedContentPos: false,
				fixedBgPos: true,
				callbacks: {
					open: () => {
						$body.css('overflow', 'hidden');
					},

					close: () => {
						$body.css('overflow', '');
					},
				},
			});
		});

		$('.gallery').each((ii, ee) => {
			$(ee).magnificPopup({
				delegate: '.gallery-item',
				type: 'inline',
				closeOnContentClick: false,
				closeOnBgClick: false,
				midClick: true,
				mainClass: 'galleries has-arrows',
				closeBtnInside: true,
				gallery: {
					enabled: true,
					arrowMarkup: `<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="icon"><svg aria-hidden="true"><use xlink:href="${assetsDistPath}/images/svg/sprite.svg#arrow-%dir%"></use></svg></span></button>`, // markup of an arrow button
					tPrev: 'Previous (Left arrow key)',
					tNext: 'Next (Right arrow key)',
				},
				fixedContentPos: false,
				fixedBgPos: true,
				callbacks: {
					open: () => {
						$body.css('overflow', 'hidden');
					},

					close: () => {
						$body.css('overflow', '');
					},
				},
			});
		});
	}

	if ($('.product-gallery-imgs:not(.product-gallery-imgs-sm) .gallery-item').length < 4) {
		$('.product-gallery-imgs').addClass('one-col');
	}

	/**
	 * Animation
	 */
	// Parallax horizontal
	gsap.registerEffect({
		name: 'moveXScroll',
		extendTimeline: true,
		defaults: { xPercent: 0, x: 0 },
		effect: (target, config) => gsap.to(target, {
			x: config.x,
			ease: 'none',
			xPercent: config.xPercent,
			overwrite: config.overwrite,
			scrollTrigger: {
				trigger: config.trigger,
				scrub: true,
				start: config.start,
				end: config.end,
				easing: 'power4.out',
			},
		}),
	});

	// Parallax vertical
	gsap.registerEffect({
		name: 'parallaxItem',
		defaults: { yPercent: 0 },
		effect: (targets, config) => gsap.to(targets, {
			yPercent: config.yPercent,
			ease: 'power4.out',
			overwrite: config.overwrite,
			scrollTrigger: {
				trigger: config.trigger,
				scrub: true,
				start: 'top top-=78px',
				end: 'bottom 80%',
			},
		}),
	});

	/**
	 * Sections inview
	 */
	const sections = gsap.utils.toArray(['section', '.section']);
	sections.forEach((section) => {
		gsap.to(section, {
			x: 0,
			scrollTrigger: {
				invalidateOnRefresh: true,
				trigger: section,
				onEnter: () => {
					$(section).addClass('fire-anim');
				},
			},
		});
	});

	$('footer').each((i, el) => {
		ScrollTrigger.create({
			invalidateOnRefresh: true,
			start: 'top 50%',
			end: 'bottom top',
			trigger: $(el),
			onEnter: () => {
				$(el).addClass('fire-anim');
			},
		});
	});

	ScrollTrigger.matchMedia({
		'(min-width: 992px)': function lg() {
			/**
			 * Heading one image
			 */
			if ($('.heading-wrapper.one-image').length) {
				gsap.to('.one-image .large-heading .line-wrapper:first-child', {
					x: 0,
					overwrite: true,
					scrollTrigger: {
						trigger: '.one-image',
						scrub: true,
						start: 'top top',
						end: 'bottom+=78px top',
						easing: 'none',
					},
				});

				gsap.to('.one-image .large-heading .line-wrapper:last-child', {
					xPercent: 10,
					overwrite: true,
					scrollTrigger: {
						trigger: '.one-image',
						scrub: true,
						start: 'top top',
						end: 'bottom+=78px top',
						easing: 'none',
					},
				});
			}

			/**
			 * Heading two images
			 */
			if ($('.two-images').length) {
				gsap.to('.imgs img', {
					yPercent: -20,
					ease: 'power4.out',
					overwrite: true,
					scrollTrigger: {
						trigger: '.heading-wrapper.two-images',
						scrub: true,
						start: 'top top-=78px',
						end: 'bottom 80%',
					},
				});
			}

			/**
			 * Parallax 2 images
			 */
			const twoImgs = $('.text-two-imgs');
			if (twoImgs.length) {
				twoImgs.each((i, e) => {
					const smImg = $(e).find('.container-small-img');
					gsap.to(smImg, {
						yPercent: -20,
						ease: 'none',
						overwrite: true,
						scrollTrigger: {
							trigger: $(e),
							scrub: true,
							start: 'top top+=78px',
							end: 'bottom top+=78px',
						},
					});
				});
			}

			/**
			 * Sticky nav blog archive
			 */
			const blogArchive = $('.blog .bloc-archive');
			if (blogArchive.length) {
				ScrollTrigger.create({
					trigger: '.content-col',
					pin: '.content-col .categories',
					pinReparent: true,
					anticipatePin: 1,
				});
			}
		},

		'(max-width: 991px)': function sm() {
			/**
			 * Heading one image
			 */
			if ($('.heading-wrapper.one-image').length) {
				gsap.to('.one-image .large-heading .line-wrapper:first-child', {
					x: 0,
					overwrite: true,
					scrollTrigger: {
						trigger: '.one-image',
						scrub: true,
						start: 'top 92px',
						end: 'bottom 92px',
						easing: 'none',
					},
				});

				gsap.to('.one-image .large-heading .line-wrapper:last-child', {
					xPercent: 10,
					overwrite: true,
					scrollTrigger: {
						trigger: '.one-image',
						scrub: true,
						start: 'top top',
						end: 'bottom 92px',
						easing: 'none',
					},
				});
			}

			/**
			 * Heading two images
			 */
			if ($('.two-images').length) {
				gsap.to('.imgs img', {
					yPercent: -20,
					ease: 'power4.out',
					overwrite: true,
					scrollTrigger: {
						trigger: '.heading-wrapper.two-images',
						scrub: true,
						start: 'top top-=92px',
						end: 'bottom 80%',
					},
				});
			}
		},
	});

	/**
	 * Window resize
	 */
	$window.resize(() => {
		$body.removeClass('panels-opened');
		navBtns.removeClass('open');
		$('.panel').removeClass('open');

		if ($window.width() >= 992) {
			btnClose.click();
		}

		ScrollTrigger.refresh();
		$('.l-navigation-wrapper').midnight('refreshMidnight');
	});

	/**
	 * Select2
	 */
	let classes = '';

	if ($('.c-form .light-theme-alt').length) {
		classes = 'light-theme-alt';
	} else if ($('.c-form .dark-theme').length) {
		classes = 'dark-theme';
	} else if ($('.c-form .light-theme').length) {
		classes = 'light-theme';
	}

	$('.select2').select2({
		dropdownCssClass: classes,
		language: 'fr',
		placeholder: $(this).data('placeholder'),
		allowClear: true,
	});

	$('.select2-no-placeholder').select2({
		dropdownCssClass: classes,
		language: 'fr',
		placeholder: $(this).data('placeholder'),
	});

	/**
	 * Random stylist tip in upsells blocks
	 */
	const $blockUpsells = $('.bloc-upsells');

	$blockUpsells.each((index, element) => {
		const $this = $(element);
		const $tips = $this.find('.product.tip .card');

		if ($tips.length) {
			$tips.hide();

			$tips.eq(randomIntFromInterval(0, ($tips.length - 1))).css('display', 'flex');
		}
	});

	/**
	 * Tips block slider
	 */
	const $blockStylistsAdviceItems = $('.stylists-advice-items');

	$blockStylistsAdviceItems.each((index, element) => {
		const $this = $(element);
		const $tips = $this.find('.stylist-card');
		const $btnRand = $this.parents('.stylists-advice').find('.randomize');

		$btnRand.on('click', () => {
			$this.slick('slickNext');
		});

		if ($this.hasClass('has-dots')) {
			$this.slick({
				arrows: false,
				fade: true,
				dots: true,
				initialSlide: randomIntFromInterval(0, ($tips.length - 1)),
			});
		} else {
			$this.slick({
				arrows: false,
				fade: true,
				initialSlide: randomIntFromInterval(0, ($tips.length - 1)),
			});
		}
	});

	const singleStoreStylistBtn = document.querySelectorAll('[data-is-store="1"]');
	if (singleStoreStylistBtn) {
		singleStoreStylistBtn.forEach((element) => {
			element.addEventListener('click', () => {
				const { storeId, appointmentUrl, id } = element.dataset;
				window.location.href = `${appointmentUrl}?id=${storeId}&stylist=${id}`;
			});
		});
	}

	/**
	 * Smooth scroll to hash on anchors
	 */
	$('a[href*="#"]').each((i, el) => {
		const target = $(el).attr('href');
		$(el).on('click', (e) => {
			if ($(target).length && !$body.hasClass('page-lookbook')) {
				e.preventDefault();

				if (!$(target).hasClass('mfp-fade') && !$(target).hasClass('collapse')) {
					$('html, body').animate({
						scrollTop: $(target).offset().top - 120,
					}, 1000);
				}
			}
		});
	});

	const setLookbookRootStyles = () => {
		const $slides = $('.m-lookbook-nav-slide');

		documentRoot.style.setProperty('--lookbook-nb-slides', $slides.length);
		documentRoot.style.setProperty('--lookbook-nb-slides-offset', `${$slides.length - 1}px`);
	};

	setLookbookRootStyles();

	/**
	 * iOS video autoplay
	 */
	const $gifVIdeo = $('.gif-video');

	if ($gifVIdeo.length) {
		$gifVIdeo.each((i, e) => {
			// eslint-disable-next-line
			enableInlineVideo($(e).get(0));
		});
	}

	/**
	 * Form radio toggle content
	 */
	if ($('.m-checkout').length) {
		const radio = $('input[type="radio"]');
		radio.each((i, e) => {
			const target = $(e).data('target');
			$(target).addClass('target');

			$(e).on('click', () => {
				$('.target').removeClass('selected');

				if ($(target).length) {
					$(target).addClass('selected');
				}
			});
		});
	}

	/**
	 * New timeline
	 * @type {Mixed|jQuery|HTMLElement|jQuery|*}
	 */
	const tlContainer = $('.timeline-container');
	const tlContent = $('.timeline-container .content-wrapper');
	const tlImgs = tlContent.find('.img');
	const img = tlImgs.find('img');
	let imgHeight = img.height();
	let wait;

	if (tlContainer.length) {
		// Transform each col into slick sliders
		const tlSlider = $('.timeline-slider');
		tlSlider.each((i, e) => {
			const $this = $(e);

			if ($this.hasClass('steps')) {
				$this.slick({
					slidesToScroll: 1,
					slidesToShow: 1,
					arrows: false,
					adaptiveHeight: true,
					asNavFor: '.imgs',
					dots: true,
					infinite: false,
					vertical: true,
					variableWidth: true,
				});
			} else {
				$this.slick({
					slidesToScroll: 1,
					slidesToShow: 1,
					arrows: false,
					infinite: false,
					fade: true,
				});
			}
		});

		// Remove extra div
		$('.timeline-slider .step, .timeline-slider .img').unwrap();

		// Bind slick dots with caroussel's button
		const slickDots = [];
		$('.slick-dots button').each((i, e) => {
			slickDots.push($(e));
		});

		$('.step-btn').each((i, e) => {
			$(e).bind('click', () => {
				slickDots[i].click();
			});
		});

		// Set min-height of the container
		// eslint-disable-next-line no-inner-declarations
		function resetTimer(timeOut) {
			function waitUpdate() {
				wait = setTimeout(() => {
					imgHeight = img.height();

					if ($window.width() > 992) {
						tlContainer.css('height', ((parseInt(imgHeight, 10) * img.length) + 5000));
						tlContainer.css('min-height', ((parseInt(imgHeight, 10) * img.length) + 5000));
					} else {
						tlContainer.css('height', 'auto');
						tlContainer.css('min-height', 'auto');
					}

					ScrollTrigger.refresh();
				}, timeOut);
			}

			if (wait !== undefined) {
				clearTimeout(wait);
				waitUpdate();
			} else {
				waitUpdate();
			}
		}

		resetTimer(loadingAnimOutDuration);
		if ($window.width() > 992) {
			tlContainer.css('height', ((parseInt(imgHeight, 10) * img.length) + 5000));
			tlContainer.css('min-height', ((parseInt(imgHeight, 10) * img.length) + 5000));
		} else {
			tlContainer.css('height', 'auto');
			tlContainer.css('min-height', 'auto');
		}

		$window.on('resize', () => {
			imgHeight = img.height();
			resetTimer(100);
		});

		// Set the timestamp for each steps
		const step = $('.timeline-slider .step');
		const timestamps = 1 / step.length;
		let stl;

		// Pin the content on scroll
		ScrollTrigger.matchMedia({
			// large
			'(min-width: 992px)': function lg() {
				stl = ScrollTrigger.create({
					invalidateOnRefresh: true,
					trigger: '.timeline-container',
					start: 'top top+=56px',
					end: 'bottom-=24px bottom',
					pin: '.timeline-container .content-wrapper',
					pinSpacing: false,
					scrub: true,
					pinReparent: true,
					fastScrollEnd: true,
					onUpdate: ({ progress }) => {
						step.each((i, e) => {
							const startPoint = i * timestamps;
							const endPoint = (i + 1) * timestamps;
							const thisBtn = e.querySelector('button');

							if (progress >= startPoint && progress <= endPoint) {
								if (!$(e).hasClass('active')) {
									$(e).addClass('active');
									thisBtn.click();
								}
							} else {
								$(e).removeClass('active');
							}
						});

						const isActiveOpened = setInterval(() => {
							if (!$('.step.active .collapse').hasClass('show') && $window.width() > 992) {
								clearInterval(isActiveOpened);
								$('.step.active button').click();
							}
						}, 100);
					},
				});
			},

			// medium
			'(max-width: 991px)': function md() {
				if (stl !== undefined) {
					stl.kill();
				}
			},
		});
	}

	/**
	 * Update Midnight if on product page
	 */
	if (productPage.length) {
		setInterval(() => {
			$('.l-navigation-wrapper').midnight('refreshMidnight');
		}, 100);
	}
});

/**
 * AJAX get nav stores medias
 */
const dataNavStoresMediasAdminAjax = document.querySelector('[data-nav-stores-medias-admin-ajax]');

if (dataNavStoresMediasAdminAjax) {
	const url = dataNavStoresMediasAdminAjax.dataset.navStoresMediasAdminAjax;
	const data = new FormData();

	data.append('action', 'get_nav_stores_medias');
	data.append('nonce', document.querySelector('[data-nav-stores-medias-nonce]').dataset.navStoresMediasNonce);

	fetch(url, {
		method: 'POST',
		credentials: 'same-origin',
		body: new URLSearchParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
	})
		.then((response) => response.json())
		// eslint-disable-next-line no-shadow
		.then((data) => {
			const shopsImgsDiv = document.querySelectorAll('.sliding-track-right .shops-imgs');

			if (shopsImgsDiv) {
				data.data.forEach((navStoresMediasItem) => {
					const template = document.createElement('template');
					template.innerHTML = navStoresMediasItem;

					shopsImgsDiv.forEach((el) => {
						el.append(template.content);
					});
				});

				/**
				 * Nav panel Shop, change img on hover link
				 */
				const shop = $('#stores .categories a');
				const shopSlider = $('.shops-imgs');

				shopSlider.slick({
					dots: false,
					arrows: false,
					fade: true,
				});

				shop.each((i, e) => {
					$(e).on('mouseenter', () => {
						shopSlider.slick('slickGoTo', i);
					});
				});
			}
		});
}

/**
 * AJAX get nav about medias
 */
const dataNavAboutMediasAdminAjax = document.querySelector('[data-nav-about-medias-admin-ajax]');

if (dataNavAboutMediasAdminAjax) {
	const url = dataNavAboutMediasAdminAjax.dataset.navAboutMediasAdminAjax;
	const data = new FormData();

	data.append('action', 'get_nav_about_medias');
	data.append('nonce', document.querySelector('[data-nav-about-medias-nonce]').dataset.navAboutMediasNonce);

	fetch(url, {
		method: 'POST',
		credentials: 'same-origin',
		body: new URLSearchParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
	})
		.then((response) => response.json())
		// eslint-disable-next-line no-shadow
		.then((data) => {
			const aboutImgsDiv = document.querySelectorAll('.sliding-track-right-about');

			if (aboutImgsDiv) {
				data.data.forEach((navAboutMediasItem) => {
					const template = document.createElement('template');
					template.innerHTML = navAboutMediasItem;

					aboutImgsDiv.forEach((el) => {
						el.append(template.content);
					});
				});
			}

			/**
			 * iOS video autoplay
			 */
			const $aboutVideo = $('.sliding-track-right-about video');

			if ($aboutVideo.length) {
				$aboutVideo.each((i, e) => {
					// eslint-disable-next-line
					enableInlineVideo($(e).get(0));
				});
			}
		});
}

/**
 * AJAX get lookbook details
 */
const dataLookbookDetailsAdminAjax = document.querySelector('[data-lookbook-details-admin-ajax]');

if (dataLookbookDetailsAdminAjax) {
	const url = dataLookbookDetailsAdminAjax.dataset.lookbookDetailsAdminAjax;
	const data = new FormData();

	data.append('action', 'get_lookbook_details');
	data.append('nonce', document.querySelector('[data-lookbook-details-nonce]').dataset.lookbookDetailsNonce);

	fetch(url, {
		method: 'POST',
		credentials: 'same-origin',
		body: new URLSearchParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
	})
		.then((response) => response.json())
		// eslint-disable-next-line no-shadow
		.then((data) => {
			const $body2 = $('body');

			const lookBook = document.querySelector('.m-lookbook');

			if (lookBook) {
				document.querySelector('.m-lookbook-nav').classList.remove('is-loading');

				data.data.forEach((lookbookItem) => {
					if (lookBook) {
						const template = document.createElement('template');
						template.innerHTML = lookbookItem;

						lookBook.append(template.content);
					}
				});

				/**
				 * Lookbooks
				 */
				const $mLookbookNavSlides = $('.m-lookbook-nav-slides');
				const $mLookbookNavCursor = $('.m-lookbook-nav').find('.cursor');
				const $lookbookContent = $('.m-lookbook-details');
				const lookbookSliderArgs = {
					lazyLoad: 'progressive',
					arrows: false,
					fade: true,
					infinite: false,
					edgeFriction: 0,
					variableWidth: true,
				};
				const initLookbookSlider = () => {
					const viewportDimensions = viewportSize();
					const viewportWidth = viewportDimensions.x;

					if (viewportWidth < 992 && !$mLookbookNavSlides.hasClass('slick-initialized')) {
						$mLookbookNavSlides.slick(lookbookSliderArgs);
					} else if (viewportWidth >= 992 && $mLookbookNavSlides.hasClass('slick-initialized')) {
						$mLookbookNavSlides.slick('unslick');
					}
				};

				if ($mLookbookNavSlides.length) {
					$mLookbookNavSlides.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
						$mLookbookNavSlides.find('.slick-slide').eq(nextSlide).prevAll().addClass('slick-seen');
						$mLookbookNavSlides.find('.slick-slide').eq(nextSlide).nextAll().removeClass('slick-seen');
					});

					$mLookbookNavSlides.on('afterChange', (event, slick, currentSlide) => {
						$mLookbookNavSlides.find('.slick-slide').eq(currentSlide).removeClass('slick-seen');
					});

					initLookbookSlider();

					$window.on('resize', () => {
						initLookbookSlider();
					});

					$body2.on('click', '.m-lookbook-nav-slide-name', (e) => {
						if ($mLookbookNavSlides.hasClass('slick-initialized')) {
							$mLookbookNavSlides.slick('slickGoTo', $(e.target).parents('.slick-slide').attr('data-slick-index'));
						}
					});
				}

				$body2.on('click', '.m-lookbook-nav-slide-name', (e) => {
					const $this = $(e.target);
					const $slide = $this.parents('.m-lookbook-nav-slide');

					if (!$slide.hasClass('is-active')) {
						$('.m-lookbook-nav-slide').removeClass('is-active');

						$slide.addClass('is-active');
					}
				});

				const searchParams = new URLSearchParams(window.location.search);
				if (searchParams.has('lookbook')) {
					$.magnificPopup.open({
						items: {
							src: `#lookbook-${searchParams.get('lookbook')}`,
						},
						closeBtnInside: true,
						type: 'inline',
						midClick: true,
						preload: [0, 1],
						mainClass: 'm-lookbook-details mfp-fade',
						closeOnBgClick: true,
					});
				}

				if ($lookbookContent.length) {
					$('a.m-lookbook-nav-slide-img').magnificPopup({
						closeBtnInside: true,
						type: 'inline',
						midClick: true,
						preload: [0, 1],
						mainClass: 'm-lookbook-details mfp-fade',
						closeOnBgClick: true,
					});
				}

				let siteLang;
				if (window.location.href.indexOf('/fr-') > -1) {
					siteLang = 'fr';
				} else if (window.location.href.indexOf('/en-') > -1) {
					siteLang = 'en';
				}

				const cursorSVG = $('svg.cursor-text use');
				const xlink = cursorSVG.attr('xlink:href');

				$body2.on('mouseenter', '.m-lookbook-nav-slide-img', (e) => {
					const cursorColor = $(e.target).data('cursor');
					cursorSVG.attr('xlink:href', `${xlink}${siteLang}-${cursorColor}`);

					if (!$mLookbookNavCursor.hasClass('is-visible')) {
						$mLookbookNavCursor.addClass(`is-visible ${cursorColor}`);
					}
				});

				$body2.on('mouseleave', '.m-lookbook-nav-slide-img', () => {
					if ($mLookbookNavCursor.hasClass('is-visible')) {
						$mLookbookNavCursor.removeClass('is-visible black white');
					}
				});

				$body2.on('mousemove', '.m-lookbook-nav-slide', (e) => {
					documentRoot.style.setProperty('--mouse-x', `${e.clientX}px`);
					documentRoot.style.setProperty('--mouse-y', `${e.clientY}px`);
				});

				const overflowedContent = document.querySelector('.m-lookbook-details-overflow');
				if (overflowedContent) {
					document.onkeydown = (e) => {
						if (e.keyCode === 37 || e.keyCode === 65) {
							overflowedContent.scrollLeft -= 50;
						}

						if (e.keyCode === 39 || e.keyCode === 68) {
							overflowedContent.scrollLeft += 50;
						}
					};
				}
			}
		});
}

/**
 * Window load
 */
$window.on('load', () => {
	/**
	 * Scroll to top
	 */
	if (!window.location.hash) {
		$('html, body').animate({
			scrollTop: 0,
		}, 1);

		if ('scrollRestoration' in window.history) {
			window.history.scrollRestoration = 'manual';
		}
	}

	/**
	 * Scroll to hashtag
	 */
	scrollToHashtagOnLoad();

	/**
	 * Set BODY classes
	 */
	$body.removeClass('is-loading').addClass('dom-is-loaded');

	setTimeout(() => {
		$body.addClass('is-anim-ready');
	}, loadingAnimOutDuration);
});
